// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.close[data-v-53fc53c4]:hover {
  background-color: #ddd;
  color: #222;
}

/* Vue Animations */
.notification-enter[data-v-53fc53c4] {
  opacity: 0;
  transform: translateX(384px);
}
.notification-leave-to[data-v-53fc53c4] {
  opacity: 0;
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.notification-leave-active[data-v-53fc53c4] {
  position: absolute;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
